import axiosInstance from 'api/axiosInstance';
import { URL_SCHEDULER_V4_PATROLS } from 'constants/urls';

/**
 * Create a single patrol assignment via the granular V4 API.
 * Does NOT use full-replacement — only creates the one patrol.
 *
 * @param {Object} patrol - Patrol data
 * @param {number} patrol.CustomerId - Customer ID
 * @param {number} patrol.AddressId - Address/site ID
 * @param {number} patrol.ContactId - Guard's contact ID
 * @param {string|Date} patrol.StartTime - Start time
 * @param {string|Date} patrol.EndTime - End time
 * @param {string} [patrol.Type] - Patrol type (default: 'patrol')
 * @param {Array} [patrol.Checklists] - Array of { ChecklistID: number }
 * @returns {Promise<Object>} Created patrol data from the API
 */
const createSinglePatrol = async (patrol) => {
  try {
    const { data } = await axiosInstance({
      method: 'POST',
      url: URL_SCHEDULER_V4_PATROLS,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
      data: {
        CustomerId: patrol.CustomerId,
        AddressId: patrol.AddressId,
        ContactId: patrol.ContactId,
        StartTime: patrol.StartTime instanceof Date ? patrol.StartTime.toISOString() : patrol.StartTime,
        EndTime: patrol.EndTime instanceof Date ? patrol.EndTime.toISOString() : patrol.EndTime,
        Type: patrol.Type || 'patrol',
        Checklists: patrol.Checklists || [],
      },
    });

    if (!data.success) {
      throw new Error(data.error?.message || 'Failed to create patrol');
    }

    return data.data;
  } catch (error) {
    console.error('[createSinglePatrol] Failed:', error);
    throw error;
  }
};

export default createSinglePatrol;
